<script>
    let notice = "";

    async function getNotice() {
        const url = `https://www.1hg.org/programme_addition_explorers`;
        const response = await fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(`${url}?t=${new Date().getTime()}`)}`);
        const data = await response.text();
        return data;
    }
    getNotice().then( data => {
        notice = data;
    });

</script>
<div class="wrapper">
    <div class="notice">
        {@html notice}
    </div>
    <div class="socials">
        <div><a href="https://twitter.com/1hgscouts" class="fa fa-twitter"></a><br/><a href="https://twitter.com/1hgscouts">@1hgscouts</a></div>
        <div><a href="https://instagram.com/1hgexplorers" class="fa fa-instagram"></a><br/><a href="https://instagram.com/1hgexplorers">@1hgexplorers</a></div>
        <div><a href="https://facebook.com/1hgscouts" class="fa fa-facebook"></a><br/><a href="https://facebook.com/1hgscouts">/1hgscouts</a></div>
    </div>
    <p class="clear">
        <span class="bold">Notice to Parents/Guardians</span><br/>
        Online Scout Manager is how we communicate by default. Please make sure to check
        your e-mail for details of nights and events where locations and times deviate
        from the standard. If you miss an email, or think you may have, check OSM, where
        you can see an archive of recent emails sent.
    </p>

    <p class="extra_notice">
        Missed a week and not sure what's happening?<br/>
        Check with one of the leaders below or email explorers@1hg.org
    </p>

    <table class="leaders">
        <tr>
            <td>ESL</td><td>Graeme Lawton - 0775 169 7156</td>
            <td class="right">AESL</td><td>Lia Woodworth - 07787 501 046</td>
        </tr>
        <tr>
            <td>AESL</td><td>Davina Broadbent - 07493 592 229</td>
            <td class="right">AESL</td><td>Adrian Gray - 07341 814 219</td>
        </tr>
    </table>
</div>

<style>
    div.notice {
        text-align: center;
        width: 600px;
        margin: 0 auto;
        background: #006ddf;
        color: #fff;
        border: 1px solid #003982;
        -webkit-print-color-adjust: exact;
    }
    div.socials {
        text-align: center;
        width: 600px;
        margin: auto;
        min-height: 200px;
    }
    .clear {
        clear: both;
    }
    div.socials > div {
        float: left;
    }
    .fa {
            padding: 20px;
            font-size: 130px;
            width: 140px;
            text-decoration: none;
            /* margin: 5px 80px; */
    }
    div.wrapper {
        width: 90%;
        margin: 0 auto;
        padding-top: 100px;
    }
    span.bold {
        font-weight: bold;
    }
    p.extra_notice {
        text-align: center;
        color: #33f;
    }
    td.right {
        padding-left: 40px;
    }
</style>